export default "__VITE_ASSET__CXcxMIPR__"